/** PM's real short/legacy task links. This parser never fetches a destination. */
export function parsePmTaskUrl(input: string): { id: string; url: string } | null {
  if (new TextEncoder().encode(input).length > 2048 || /[\x00-\x1f\x7f\\]/.test(input)) return null;
  let raw = input.trim();
  if (/^(pm0\.ru|pm\.openstart\.ru)\//i.test(raw)) raw = `https://${raw}`;
  // Check the raw authority before URL normalization: :443, encoded hosts and
  // credentials can otherwise disappear or normalize into an allowed hostname.
  if (!/^https?:\/\/(?:pm0\.ru|pm\.openstart\.ru)(?=\/|\?|#|$)/i.test(raw)) return null;
  let url: URL;
  try { url = new URL(raw); } catch { return null; }
  const rawPath = raw.replace(/^https?:\/\/[^/?#]+/i, '').split(/[?#]/, 1)[0] || '/';
  if (rawPath !== url.pathname) return null;
  const short = /^\/([1-9]\d{0,9})\/?$/.exec(url.pathname);
  let id = short?.[1];
  if (!id && (url.pathname === '/' || url.pathname === '/index.php')) {
    if (url.searchParams.getAll('action').length !== 1 || url.searchParams.get('action') !== 'tasks_view'
      || url.searchParams.getAll('task_id').length !== 1
      || [...url.searchParams.keys()].some(key => /^(?:task_id|action)\[/.test(key))) return null;
    id = url.searchParams.get('task_id') ?? undefined;
  }
  if (!id || !/^[1-9]\d{0,9}$/.test(id) || Number(id) > 2147483647) return null;
  return { id, url: url.href };
}
